import BaseApi from '../baseApi';
import utilsStorage from '@/utils/storage';

/* As releases vêm do backend do próprio TechCâmbio, que consulta o Backoffice
   com o INSTANCE_REF desta implantação (nada de UUID fixo no build). */
export class ReleasesApi extends BaseApi {
  constructor(obj) {
    obj = obj || {};
    super(obj);
  }

  async getReleases() {
    return this.api.get('/releases');
  }
}

/* Menu.vue e ReleasesModal.vue leem `response.data` (array). */
async function getReleases() {
  const response = await new ReleasesApi(utilsStorage.getUserOnStorage()).getReleases();

  return { data: Array.isArray(response?.data) ? response.data : [] };
}

export default {
  getReleases,
};
